<mc-application-messages #notification class="notification-container" duration-in-ms="10000"></mc-application-messages>

<mc-window #saveLayerWindow id="saveLayerWindow" title="Save Layer" is-draggable="true" is-resizable="true"
           [width]="800" [maxHeight]="800" top="100">
    <mc-save-layer #saveLayer slot="content" enable-folders="true"></mc-save-layer>
</mc-window>

<mc-window #saveMapWindow id="saveMapWindow" title="Save Map" is-draggable="true" is-resizable="true" min-width="500"
           min-height="400"  top="100">
    <mc-save-map #saveMap slot="content"></mc-save-map>
</mc-window>

<mc-window #shareMapWindow id="shareMapWindow" title="Share Map" is-draggable="true" is-resizable="true" min-width="500"
           min-height="400">
    <mc-share-map #shareMap slot="content"></mc-share-map>
</mc-window>

<mc-window #unshareMapWindow id="unshareMapWindow" title="Unshare Map" is-draggable="true" is-resizable="true"
           min-width="500" min-height="400">
    <mc-unshare-map #unshareMap slot="content"></mc-unshare-map>
</mc-window>

<mc-window #filterLayerOptionsWindow id="filterLayerOptions" title="Filter Layer Options" modal="true" width="600">
    <div slot="content">
        <h4>Select a filter option for each layer.</h4>
        <div *ngFor="let layer of selectedLayers" class="selected-layer">
            <span>{{ layer.name }}</span>
            <div class="fieldset-radio filter-type-picker">
                <label><input type="radio" [name]="layer" value="showAll" [(ngModel)]="layer.filterType">Show All</label>
                <label class="margin-left-1"><input type="radio" [name]="layer" value="filter" [(ngModel)]="layer.filterType">Filter</label>
                <label class="margin-left-1" *ngIf="defaults && defaults.length"><input type="radio" [name]="layer" value="defaults" [(ngModel)]="layer.filterType">User Defaults</label>
                <label class="margin-left-1" *ngIf="layer.aoiQuery?.field || layer.aoiQuery?.subqueries"><input type="radio" [name]="layer" value="aoi" [(ngModel)]="layer.filterType">AOI</label>
                <label class="margin-left-1" *ngIf="layer.aoiQuery && !layer.aoiQuery.field && !layer.aoiQuery.subqueries && isAoiSpatialQueryable"><input type="radio" [name]="layer" value="spatialAoi" [(ngModel)]="layer.filterType">AOI (spatial)</label>
            </div>
        </div>
        <div class="text-right">
            <button class="btn btn-small margin-right-1" (click)="setFilters()">Next</button>
            <button class="btn btn-small margin-right-third" (click)="closeFilterLayerOptionsWindow()">Cancel</button>
        </div>
    </div>
</mc-window>

<mc-window id="exportLayerFilter" title="Export Layer" modal="true" width="600">
    <div slot="content">
        <fieldset class="fieldset-checkbox">
            <legend id="exportLayerLegend"></legend>
            <label *ngFor="let childTable of childTables">
                <input type="checkbox" name="child" value="{{childTable.checked}}" [(ngModel)]="childTable.checked" />
                {{ childTable?.layerChildRelationshipName }}
            </label>
        </fieldset>
        <button class="btn btn-small btn-red" style="float: right;" (click)="closeExportLayerFilterWindow()">Cancel</button>
        <button class="btn btn-small" style="float: right; margin-right: 10px;" (click)="exportLayerWithChildTables()">Ok</button>
    </div>
</mc-window>


<mc-window #exportMapWindow title="Export Map" modal="true" width="400">
    <div slot="content">
        <mc-export-map #exportMap></mc-export-map>
    </div>
</mc-window>

<!-- Layer Filter -->
<mc-window #layerFilterWindow id="layerFilterWindow" title="Layer Filter" is-resizable="true" is-draggable="true"
           height="700" width="960">
    <div slot="content">
        <mc-layer-filter-container #layerFilter id="layerFilter" enable-geographic-filter="false" enable-join-filter="false" enable-child-record-filter="false"></mc-layer-filter-container>
    </div>
</mc-window>

<mc-window #symbolEditorWindow id="symbolEditorWindow" title="Symbol Editor" is-draggable="true" is-resizable="true"
           width="530" top="75" left="300">
    <mc-symbol-editor-container #symbolEditor id="symbolEditor" slot="content">
        <mc-point-symbol-editor slot="point-symbol-editor"></mc-point-symbol-editor>
        <mc-line-symbol-editor slot="line-symbol-editor"></mc-line-symbol-editor>
        <mc-polygon-symbol-editor slot="polygon-symbol-editor"></mc-polygon-symbol-editor>
        <mc-text-symbol-editor slot="text-symbol-editor"></mc-text-symbol-editor>
        <mc-layer-opacity-editor slot="layer-opacity-editor"></mc-layer-opacity-editor>
    </mc-symbol-editor-container>
</mc-window>

<!-- Min Max Scale -->
<mc-window #minMaxScaleWindow id="minMaxScaleWindow" title="Min/Max Scale" is-draggable="true" is-resizable="true" width="580" top="100">
    <mc-min-max-scale #minMaxScale id="minMaxScale" slot="content" (onclose)="closeMinMax()"></mc-min-max-scale>
</mc-window>

<mc-window #identifyToggleWindow id="identifyToggleWindow" title="Control Layers in Identify Window" is-draggable="true"
           is-resizable="true" min-width="500" min-height="400">
    <div slot=content>
        <om-identify-toggle #identifyToggle id="identifyToggle">
        </om-identify-toggle>
    </div>
</mc-window>

<mc-window #layerLabelsWindow id="layerLabelsWindow" title="Layer Labels" is-draggable="true" is-resizable="true" width="580" top="100">
    <mc-layer-labels #layerLabels id="layerLabels" slot="content"></mc-layer-labels>
</mc-window>

<mc-window #layerSpatialQueryWindow id="layerSpatialQueryWindow" title="Spatial Query" is-draggable="true"
           is-resizable="true" height="700" width="960">
    <mc-layer-spatial-query #layerSpatial id="layerSpatial" slot="content"></mc-layer-spatial-query>
</mc-window>

<mc-export-layer id="exportLayer" #exportLayer style="display:none"></mc-export-layer>

<mc-window #importExternalMapWindow id="importExternalMapWindow" title="Import AGOL Map" modal="true">
    <mc-import-external-map #importExternalMap slot="content"></mc-import-external-map>
</mc-window>

<mc-window #themeEditorWindow id="themeEditorWindow" title="Theme Editor" is-draggable="true" is-resizable="true"
           height="650px" width="800px">
    <mc-theme-editor #themeEditor slot="content" use-symbol-scheme="true" use-esri-scheme="true"></mc-theme-editor>
</mc-window>

<mc-window #bufferWindow id="bufferWindow" modal="true">
    <mc-buffer #buffer slot="content"></mc-buffer>
</mc-window>

<mc-window #imageWindow id="imageWindow" title="Image Gallery" modal="true">
    <mc-gallery #imageGallery id="imageGallery" slot="content"></mc-gallery>
</mc-window>

<mc-window #esriErrorWindow id="esriErrorWindow" title="Error" modal="true">
    <div slot="content">
        <span>{{ esriErrorMessage }}</span>
    </div>
</mc-window>

<!-- Body -->
<om-app-nav-menu #navMenu class="block-display flex-shrink" [mapRef]="map" [openVL]="openVL.asObservable()" [openSV]="openSV.asObservable()" (disableIdentify)="disableIdentify($event)"
              (userSettingsChange)="userSettingsChange($event)" (onResetPress)="onResetPress()" (onResetConfirm)="onResetConfirm()" (onShowOverview)="showOverview = $event"
			  (openShareMap)="openShareMap($event)" [openShareLayer]="openShareLayer.asObservable()" [streetViewDefaultLocation]="lastIdentifiedPointCRS" [isIdentifyDialogOpen]="isIdentifyDialogOpen">
</om-app-nav-menu>

<div class="flex-grow flex-display flex-row flex-height-fix">
    <aside class="side-nav flex-shrink flex-display flex-col flex-height-fix" aria-role="complementary" aria-label="Legend"
           [ngClass]="{ 'closed': !sideOpen }">
        <mc-map-info-container slot="map-action" class="flex-shrink">
            <div slot="option-menu" class="dropdown js-dropdown">
                <button class="btn dropdown-btn js-dropdown-toggle icon-ui-settings icon-ui-white icon-only-btn"
                        tabindex="0" aria-haspopup="true" aria-expanded="false"></button>
                <nav class="dropdown-menu dropdown-right" role="menu" aria-label="Map Options">
                    <button class="dropdown-link btn" role="menuitem" (click)="openImportExternalMapWindow()"><span class="icon-ui-applications"></span> Import AGOL Map</button>
                    <button *ngIf="isLoggedIn" class="dropdown-link btn" role="menuitem" (click)="openSaveMapWindow()"><span class="icon-ui-save"></span> Save Map</button>
                    <button *ngIf="isLoggedIn" class="dropdown-link btn" role="menuitem" (click)="openShareMap()"><span class="icon-ui-share"></span> Share Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openSpatialQueryWindow()"><span class="icon-ui-locate"></span> Spatial Query</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openMapPrintWindow()"><span class="icon-ui-printer"></span> Print Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openMergeMap()"><span class="icon-ui-collection"></span> Merge Another Map</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openExportMap()"><span class="icon-ui-download"></span> Export Map to Excel</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openAllDataTables()"><span class="icon-ui-table"></span> Open All Data Tables</button>
                    <button class="dropdown-link btn" role="menuitem" (click)="openIdentifyToggleWindow()"> Control Identify</button>
                </nav>
            </div>
        </mc-map-info-container>
        <div class="legend-area flex-grow flex-height-fix scroll">
            <mc-legend class="block-display" #legend slot="legend" show-layer-detail="false" (optionSelectedEvent)="onOptionSelect($event)"
                       (groupOptionSelectedEvent)="groupOptionSelected($event)" (attached)="optionsAttached($event)" (onsymbolchange)="onSymbolChange($event)">
                <div slot="legend-layer-options" class="dropdown js-dropdown">
                    <button class="btn btn-transparent icon-ui-filter filter-option" role="menuitem" title="Filter"></button>
                    <button class="btn btn-transparent dropdown-btn icon-ui-settings layer-options-button" tabindex="0"
                            aria-haspopup="true" aria-expanded="false"></button>
                    <nav class="dropdown-menu dropdown-right" role="menu" aria-label="Layer Options">
                        <button class="dropdown-link details" role="menuitem"><span class="icon-ui-description"></span> Details</button>
                        <button class="dropdown-link data-dictionary-option" role="menuitem" *ngIf="isInternal"><span class="icon-ui-review"></span> Data Dictionary</button>
                        <button class="dropdown-link filter-option" role="menuitem"><span class="icon-ui-filter"></span> Filter</button>
                        <button class="dropdown-link data-table-option" role="menuitem"><span class="icon-ui-table"></span> Data Table</button>
                        <button class="dropdown-link zoom-option" role="menuitem"><span class="icon-ui-zoom-in-magnifying-glass"></span> Zoom to Layer</button>
                        <button class="dropdown-link theme-editor-option" role="menuitem"><span class="icon-ui-pie-chart"></span> Theme Editor</button>
                        <button class="dropdown-link spatial spatial-query-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-locate"></span> Spatial Query</button>
                        <button class="dropdown-link spatial renew-spatial-query-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-refresh"></span> Renew Spatial Query</button>
                        <button class="dropdown-link buffer-layer-option" role="menuitem"><span class="icon-ui-layers"></span> Buffer Layer</button>
                        <button class="dropdown-link export-excel-option" role="menuitem"><span class="icon-ui-download"></span> Export Excel</button>
                        <button class="dropdown-link export-shapefile-option" role="menuitem"><span class="icon-ui-download"></span> Export Shapefile</button>
                        <button class="dropdown-link copy-option" role="menuitem"><span class="icon-ui-duplicate"></span> Copy</button>
                        <button class="dropdown-link save-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-save"></span> Save</button>
                        <button class="dropdown-link share-option" role="menuitem" *ngIf="isLoggedIn"><span class="icon-ui-share"></span> Share</button>
                        <button class="dropdown-link min-max-option" role="menuitem"><span class="icon-ui-zoom-in-fixed"></span> Min/Max Scale</button>
                        <button class="dropdown-link labels-option" role="menuitem"><span class="icon-ui-blank-map-pin"></span> Labels</button>
                        <button class="dropdown-link delete-option" role="menuitem"><span class="icon-ui-close"></span> Remove Layer</button>
                    </nav>
                </div>
                <div slot="legend-layer-group-options">
                    <button class="btn btn-transparent icon-ui-close delete-option" role="menuitem"></button>
                </div>
            </mc-legend>
        </div>
        <button class="expander icon-ui-up-down-arrows btn btn-white" (click)="sideOpen = !sideOpen;"></button>
    </aside>
    <div class="flex-grow">
        <mc-map id="mc-map" #map center="[-77.6362661695295, 40.92039887644528]" rotate="false" zoom="8" show-attribution="true" (largerImageRequest)="onLargerImageRequest($event)" (largerVideoRequest)="onLargerVideoRequest($event)">
            <div slot="top-left">
                <mc-extent #extent app-name="OneMap"></mc-extent>
                <mc-expander expand-icon-class="esri-icon-basemap" auto-collapse="true" expand-tooltip="Basemap" style="display:block;margin-top: 10px;">
                    <mc-basemap-switcher #basemapSwitcher></mc-basemap-switcher>
                </mc-expander>
                <div id="nearbyAssetsToggle" class="nearby-assets-toggle" *ngIf="showNearbyAssetsBtn()">
                    <label>
                        <input id="nearbyAssetsToggleCheckBox" type="checkbox" (change)="toggleNearbySearch($event)" hidden>
                        <img src="assets/nearby-icon.png" alt="Nearby Assets" title="Nearby Assets">
                    </label>
                </div>
            </div>
            <mc-identify #identifyWindow slot="top-right" [showVideologBtn]="true" [showStreetViewBtn]="true" [internal]="isInternal" [showNearbyAssetsBtn]="showNearbyAssetsBtn()" [findNearestSegment]="true"
                         (bufferFeature)="openFeatureBufferWindow($event)" (openVideologEvent)="openVideolog($event)" (openStreetViewEvent)="openStreetView($event)" (identifiedCRS)="setStreetViewDefaultLocation($event)"></mc-identify>
            <mc-import-shapefile #importShapefile id="importShapefile" (onfiledrop)="onImportShapefileDrop($event)" (onfiledone)="onImportShapefileDone($event)"></mc-import-shapefile>
            <mc-overview-map [hidden]="!showOverview" slot="bottom-left"></mc-overview-map>
        </mc-map>
    </div>
    <aside class="print-area flex-shrink flex-display flex-col flex-height-fix" aria-role="complementary" aria-label="Print"
           [ngClass]="{ 'closed': !printOpen, 'ready': printReady }" [ngStyle]="{ 'display': (printActive ? '' : 'none') }">
        <div class="print-area-header" [ngClass]="{ 'hidden': !printOpen }">
            <span class="print-area-title">Print Map</span>
            <button class="close icon-ui-close btn" (click)="closePrint()" title="Cancel Print"></button>
        </div>
        <mc-print #print class="flex-grow flex-height-fix scroll"></mc-print>
        <button class="expander icon-ui-up-down-arrows btn btn-white" (click)="toggleCollapsePrintArea()" title="Hide Print"></button>
    </aside>
</div>
<div class="data-table-container" [ngClass]="{ 'closed': dataTableMinimized, 'hidden': !dataTable.opened }">
    <mc-data-table #dataTable autogenerate-column-settings="true" max-default-Columns="11" page-size="40" [ngClass]="{ 'closed': dataTableMinimized }">
    </mc-data-table>
    <button class="data-expander icon-ui-up-down-arrows btn btn-white"
            (click)="dataTableMinimized = !dataTableMinimized;"></button>
</div>
<div *ngIf="isLoading" class="loader is-active padding-leader-3 padding-trailer-3">
    <div class="loader-bars"></div>
</div>
